import type { UserRole } from "@/types";
import { hasPermission, resolveBackofficeArea } from "@/utils";
import { ADMIN_NAV_ITEMS } from "./adminNav";
import type { BackofficeNavItem } from "./backofficeNav.types";
import { MANAGER_NAV_ITEMS } from "./managerNav";
import { MODERATOR_NAV_ITEMS } from "./moderatorNav";

const NAV_BY_AREA = {
  admin: ADMIN_NAV_ITEMS,
  moderar: MODERATOR_NAV_ITEMS,
  manager: MANAGER_NAV_ITEMS,
} as const;

const filterNavItemsByPermission = (
  role: UserRole,
  items: readonly BackofficeNavItem[],
): readonly BackofficeNavItem[] =>
  items.filter(
    (item) => !item.permission || hasPermission(role, item.permission),
  );

/** Returns sidebar nav items for the active backoffice area and role. */
export const getBackofficeNavItems = (
  role: UserRole,
  pathname: string,
): readonly BackofficeNavItem[] => {
  const area = resolveBackofficeArea(pathname);
  return filterNavItemsByPermission(role, NAV_BY_AREA[area]);
};
